export const clearAuthData = state => {
    state.authResponse = null
    localStorage.removeItem('accessToken')
    window.location = '/login'        
}

export const setUserauthResponse = (state, payload) => {
    state.authResponse = payload
    let accessToken = payload.access_token
    localStorage.setItem('accessToken', accessToken)    
}


// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js